<template>
  <v-container>
    <v-layout row wrap mt-5>
      <v-flex md9 xs12>
        <v-img :src="imageUrl" aspect-ratio="2"></v-img>
      </v-flex>
      <v-flex md3 xs12>
        <div class="container">
          <h2 class="mb-4">Download Image</h2>

          <!-- <a
            :href="'https://pixabay.com/get/'+img_id+'_150.jpg?attachment&modal'"
            class="v-btn theme--dark orange"
          >Download _150p</a>
          <a
            :href="'https://pixabay.com/get/'+img_id+'_640.jpg?attachment&modal'"
            class="v-btn theme--dark blue"
          >Download _640p</a>
          <a
          :href="'https://pixabay.com/get/'+img_id+'_1280.jpg?attachment&modal'"
          class="v-btn theme--dark green"
          >Download _1280p</a>
          <a
          :href="'https://pixabay.com/get/'+img_id+'_1920.jpg?attachment&modal'"
          class="v-btn theme--dark pink"
          >Download _1920p</a> -->
          <a
            :href="'https://pixabay.com/get/'+img_id+'_640.jpg?attachment&modal'"
            class="v-btn theme--dark blue"
          >Download</a>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
export default {
  name: "viewimage",
  data() {
    return {
      title: "view image"
    };
  },

  computed: {
    imageUrl: function() {
      var img_id = this.$route.params.imgUrl;
      return `https://pixabay.com/get/${img_id}_1280.jpg`;
    },
    downloadImg: function() {
      var img_id = this.$route.params.imgUrl;
      return `https://pixabay.com/get/${img_id}_1280.jpg?attachment&modal`;
    },
    img_id: function() {
      return this.$route.params.imgUrl;
    }
  }
};
</script>
